module.exports = __webpack_public_path__ + "img/chevron-right.d586bc38.svg";